import http, { CLIENT_ID_KEY } from 'api/http'
import { getVezgoToken } from 'api/integrations/services'
import { Auth } from 'aws-amplify'
import { SUPPORTED_INTEGRATIONS } from 'modules/integrations/IntegrationsTab/consts'
import Vezgo from 'vezgo-sdk-js'

interface IVezgoAPI extends ReturnType<typeof Vezgo.init> {}

interface IVezgoAccount {
	provider: {
		display_name: string
	}
}

export default class VezgoService {
	static vezgo: IVezgoAPI
	static vezgoUser: ReturnType<typeof this.vezgo.login>

	static async init() {
		if (!process.env.NEXT_PUBLIC_VEZGO_CLIENT_ID) throw new Error('Vezgo Client ID is not provided')
		const session = await Auth.currentSession()
		const token = session.getAccessToken().getJwtToken()
		const clientId = http.getStorageItem(CLIENT_ID_KEY)

		this.vezgo = Vezgo.init({
			clientId: process.env.NEXT_PUBLIC_VEZGO_CLIENT_ID,
			auth: {
				headers: {
					Authorization: `Bearer ${token}`,
					...(clientId && {
						'client-id': clientId,
					}),
				},
			},
			authorizer: async callback => {
				try {
					const vezgoResponse = await getVezgoToken()
					callback(null, vezgoResponse)
				} catch (error) {
					callback(error)
				}
			},
		})

		this.vezgoUser = this.vezgo.login()
	}

	static startWidget(
		onSuccess: (accountId: string) => Promise<void>,
		onError: (error: { account: string; error_type: string; message: string }) => void
	) {
		this.vezgoUser
			.connect({
				providers: SUPPORTED_INTEGRATIONS,
			})
			.onConnection(onSuccess)
			.onError(onError)
	}

	static getAccountInfo(accountId: string): Promise<IVezgoAccount | undefined> {
		return this.vezgoUser.accounts.getOne(accountId)
	}
}
